export interface IExchMarket {
  exchmktId: string
  displayName: string
  exchId: string
  exchName: string
  exchCode: string
  marketId: string
  marketName: string
  baseCurrencyCode: string
  quoteCurrencyCode: string
  baseIsFiat: boolean | string
  quoteIsFiat: boolean | string
  baseCurrencyName: string
  quoteCurrencyName: string
  quantityPrecision: number | string
  pricePrecision: number | string
  lastTradePrice: number | string
  volume24: number | string
  miniChartData: any[] | string
  exchSlug: string
  volume24Btc: number | string
  btcPrice: number | string
  percentChange: number | string
}

export class ExchMarket implements IExchMarket {
  constructor(
    public exchmktId: string = '',
    public displayName: string = '',
    public exchId: string = '',
    public exchName: string = '',
    public exchCode: string = '',
    public marketId: string = '',
    public marketName: string = '',
    public baseCurrencyCode: string = '',
    public quoteCurrencyCode: string = '',
    public baseIsFiat: boolean | string = '',
    public quoteIsFiat: boolean | string = '',
    public baseCurrencyName: string = '',
    public quoteCurrencyName: string = '',
    public quantityPrecision: number | string = '',
    public pricePrecision: number | string = '',
    public lastTradePrice: number | string = '',
    public volume24: number | string = '',
    public miniChartData: any[] | string = '',
    public exchSlug: string = '',
    public volume24Btc: number | string = '',
    public btcPrice: number | string = '',
    public percentChange: number | string = ''
  ) {}
}

export default ExchMarket 